import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./axiosHelper";

// Display all POD List
export const getPODList = createAsyncThunk('data/getPODList',
  async(data)=>{
    const res = await axiosInstance.get(`/api/v1/getPodDetails?page=${data.page}&limit=${data.limit}`);
      return res.data
  }
)

//Delete POD Details
export const deletePODDetails = createAsyncThunk('data/deletePODDetails',
  async(data)=>{
    const res = await axiosInstance.delete(`/api/v1/deletePODDetails/${data}`);
      return res.data
    }
)
//create pod
export const createPodDetails = createAsyncThunk('data/createPodDetails',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/createPodDetails', data);
      return res.data
  }
)

//update pod details
export const updatePODDetails = createAsyncThunk('data/updatePODDetails',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/updatePodDetails', data);
      return res.data
  }
)
// uploadPodProof
export const uploadPodProof = createAsyncThunk('data/uploadPodProof',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/addImageInPod/PodImage', data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      return res.data
  }
)
// getPodImageByPodID
export const getPodImageByPodID = createAsyncThunk('data/getPodImageByPodID',
  async(data)=>{
    const res = await axiosInstance.get(`/api/v1/getPodImageByPodId/${data}`);
      return res.data
  }
)